import { gql } from "@apollo/client";

export const GET_REQUISITO_CLIENTE = gql`
query GetRequisitoCliente($codCliente: String!) {
    requisitoClienteByClienteId(codCliente: $codCliente)
    {
        cod_Sap
        mail
        pers_Contacto
        idTmpFact
        dia_Inicio_Fact_Mensual
        dia_Fin_Fact_Mensual
        autorizaciones
        conformidades
        enfermeria
        remito_NH
        iDTipoRemitoNH
        remito_FK
        iDTipoRemitoFK
        prescripcion
        validacion
        documentacion_Pac
        observaciones
        fA
        enfermeriaGuardia
        nutricionista
        fonoaudiologo
        psicologo
        kinesiologo
        tocupacional
        asocial
        psiquiatra
        cargo
        telefono
        docRespaldatoria
        presentacionFact
        mailFact
        idTipoAutorizacion
        idTipoAutorizacionNavigation{
            descripcion
        }
        minuta_DNI
        minuta_nombreApellido
        minuta_nroAfiliado
        minuta_nroOC
        minuta_nroRemito
        editaFechaHasta
        aprobacionMasiva
        bloqueoPaciente
        bloqueoProrroga
        bloqueoCotizar
        bloqueoEnvio
        subVentas
        telemedicina
        idTmpFactNavigation {
            cantDias
        }
    }
}
`;

export const adaptRequisitoCliente = (requisitoClienteByClienteId) => {
  return {
    idTipoAutorizacion: requisitoClienteByClienteId?.idTipoAutorizacion,
    bloqueoPaciente: requisitoClienteByClienteId?.bloqueoPaciente,
    bloqueoProrroga: requisitoClienteByClienteId?.bloqueoProrroga,
    bloqueoCotizar: requisitoClienteByClienteId?.bloqueoCotizar,
    bloqueoEnvio: requisitoClienteByClienteId?.bloqueoEnvio,
    telemedicina: requisitoClienteByClienteId?.telemedicina,
    diasMaxFactCliente: requisitoClienteByClienteId?.idTmpFactNavigation?.cantDias,
    subVentas: requisitoClienteByClienteId?.subVentas,
    editaFechaHasta: requisitoClienteByClienteId?.editaFechaHasta
  };
};